<template>
  <v-expansion-panels v-model="panel" multiple focusable>
    <v-expansion-panel readonly>
      <v-expansion-panel-header hide-actions>
        <v-row dense class="font-weight-bold">
          <v-col cols="2" class="text-left">Data</v-col>
          <v-col cols="2" class="text-left ml-n1">Fila</v-col>
          <v-col cols="2" class="text-left ml-n1">Origem</v-col>
          <v-col cols="2" class="text-left ml-n6">Status</v-col>
          <v-col cols="1" class="text-left ml-n10">TC</v-col>
          <v-col cols="2" class="text-left ml-11">TA</v-col>
          <v-col cols="1" class="text-left ml-n10">TE</v-col>
        </v-row>
      </v-expansion-panel-header>
    </v-expansion-panel>
    <v-expansion-panel v-for="(item, i) in chamadasRelatorio" :key="i" :readonly="permissionOpenExpansionPanel">
      <v-expansion-panel-header>
        <div>
          <v-row dense>
            <v-col cols="2" class="text-left">{{
              item.dateStartCall != undefined
                ? moment(item.dateStartCall, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
                : ''
            }}</v-col>
            <v-col cols="2" class="text-left">{{ item.fila }}</v-col>
            <v-col class="text-left">{{ item.numeroOrigem }}</v-col>
            <v-col
              :class="
                `ml-4 ${colorVerify(item.eventos[item.eventos.length - 1].tipo)}--text font-weight-bold text-left`
              "
            >
              {{ textModify(item.eventos[item.eventos.length - 1].tipo) }}
            </v-col>
            <v-col class="text-left">{{ item.tmc }}</v-col>
            <v-col class="text-left">{{ item.tma }}</v-col>
            <v-col class="text-left">{{ item.tme }}</v-col>
          </v-row>
        </div>
        <template v-slot:actions>
          <v-icon :color="permissionOpenExpansionPanel ? 'grey lighten-1' : 'orangePcm'">$expand</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content color="background">
        <TimeLineEntrada :dadosRelatorio="item" :permissaoOuvirLigacao="permissionHearCall" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import moment from 'moment'

import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import TimeLineEntrada from '../../../../../components/TimeLineEntrada'

export default {
  name: 'ExpandListMain',
  components: { TimeLineEntrada },
  props: ['chamadasRelatorio', 'panel'],
  data: () => ({
    moment: moment,
    arrayPermissoesAbrirHistoricoRelatorio: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_TOTAL,
      process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_HISTORICO,
      process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_OUVIR_GRAVACAO,
      process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_OUVIR_GRAVACAO_HISTORICO,
    ],
    arrayPermissoesOuvirLigacao: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_TOTAL,
      process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_OUVIR_GRAVACAO,
    ],
    permissionOpenExpansionPanel: false,
    permissionHearCall: false,
  }),

  created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      // if (this.arrayPermissoesAbrirHistoricoRelatorio.includes(permissionLocalStorage)) {
      //   this.permissionOpenExpansionPanel = false
      // }

      if (this.arrayPermissoesOuvirLigacao.includes(permissionLocalStorage)) {
        this.permissionHearCall = true
      }
    })
  },

  methods: {
    ...obtainUserPermissions,

    colorVerify(type) {
      if (type === 'ABANDONADA' || type === 'NÃO ATENDIDA' || type === 'TIME OUT') {
        return 'red'
      } else if (
        type === 'ATENDIDA' ||
        type === 'DESLIGADO PELO OPERADOR' ||
        type === 'DESLIGADO PELA ORIGEM' ||
        type === 'TRANSFERENCIA'
      ) {
        return 'green'
      }
    },
    textModify(type) {
      if (type === 'ABANDONADA') {
        return 'ABANDONADA'
      } else if (
        type === 'ATENDIDA' ||
        type === 'DESLIGADO PELO OPERADOR' ||
        type === 'DESLIGADO PELA ORIGEM' ||
        type === 'TRANSFERENCIA'
      ) {
        return 'ATENDIDA'
      } else {
        return 'TRANSBORDO'
      }
    },
  },
}
</script>

<style scoped>
.titleList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-right: 90px;
  margin-left: 50px;
}
</style>
